declare global {
    interface Window {
        __single_ticket_view: {
            TICKET_API_URL: string;
            VIEWS_API_URL: string;
            SSO_CLIENT_ID: string;
            SSO_TENANCY: string;
            SSO_AUTHORITY: string;
            SSO_REDIRECT_URL: string;
        }
    }
}

const TICKET_API_URL = window.__single_ticket_view.TICKET_API_URL;
const VIEWS_API_URL = window.__single_ticket_view.VIEWS_API_URL;
const SSO_CLIENT_ID = window.__single_ticket_view.SSO_CLIENT_ID;
const SSO_TENANCY = window.__single_ticket_view.SSO_TENANCY;
const SSO_AUTHORITY = window.__single_ticket_view.SSO_AUTHORITY;
const SSO_REDIRECT_URL = window.__single_ticket_view.SSO_REDIRECT_URL;

export {
    TICKET_API_URL,
    VIEWS_API_URL,
    SSO_CLIENT_ID,
    SSO_TENANCY,
    SSO_AUTHORITY,
    SSO_REDIRECT_URL
}